import { render } from "./ProductBoxSmall.vue?vue&type=template&id=96c43f80&scoped=true&ts=true"
import script from "./ProductBoxSmall.vue?vue&type=script&lang=ts"
export * from "./ProductBoxSmall.vue?vue&type=script&lang=ts"

import "./ProductBoxSmall.vue?vue&type=style&index=0&id=96c43f80&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-96c43f80"]])

export default __exports__